export default "__VITE_ASSET__3b3817d4__"